import React, { Component } from 'react';

class Header extends Component {
  constructor() {
    super();

    this.state = {
      extraMenuItems: this.getExtraMenuItemsFromCookie(),
    };
  }

  getExtraMenuItemsFromCookie() {
    try {
      const cookieMatch = document.cookie.match(/(?:^|; )menu-items=([^;]*)/);
      if (!cookieMatch) return [];

      const decoded = decodeURIComponent(cookieMatch[1]);
      const parsed = JSON.parse(decoded);

      if (Array.isArray(parsed)) {
        return parsed.filter(
          item => item && typeof item.name === 'string' && typeof item.link === 'string'
        );
      }
    } catch (err) {
      console.warn('Invalid menu-items cookie', err);
    }
    return [];
  }

  render() {
    const { extraMenuItems } = this.state;

    return (
      <section className="hero is-light">
        <nav className="navbar" role="navigation" aria-label="main navigation">
          <div className="navbar-brand">
            <a className="navbar-item is-size-4" href="/" style={{ padding: '.5rem 1.5rem' }}>
              PerlBanjo.com
            </a>

            {extraMenuItems.map(({ name, link }) => (
              <a key={link} className="navbar-item" href={link}>
                {name}
              </a>
            ))}

            <a
              className="navbar-item"
              style={{
                height: '100%',
                margin: 0,
                padding: '.5rem 1.5rem',
                position: 'absolute',
                right: '0',
              }}
              href="/settings"
            >
              <i className="fas fa-cog"></i>
              <span className="is-hidden-mobile">&nbsp;Settings</span>
            </a>
          </div>
        </nav>
      </section>
    );
  }
}

export default Header;
